import { Stack } from "@mui/material";
import React from "react";

import {
  HubHookFormInput,
  HubIcon,
  HubMaterialHookSelect,
} from "../../components";
import { StyledCell, StyledStack } from "./styles";

const LaborMaterialsTableRow = ({ idx, item, remove = () => {} }) => {
  const prefix = `laborMaterials.${idx}`;

  return (
    <Stack backgroundColor="hubColors.white">
      <StyledStack>
        <HubMaterialHookSelect
          label={null}
          name={`${prefix}.materialId`}
          defaultValue={item?.materialId}
          departmentId={4}
          required
        />
        <HubHookFormInput
          name={`${prefix}.quantity`}
          defaultValue={item?.quantity}
          placeholder="# of numbers"
          endAdornment="g"
          isDecimal
          required
        />
        <StyledCell onClick={() => remove(idx)}>
          <HubIcon icon="X" size="10px" />
        </StyledCell>
      </StyledStack>
    </Stack>
  );
};

export default LaborMaterialsTableRow;
